import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import subscriberService from '../../services/subscriber.service'
import addonService from '../../services/addon.service'
import subscriberApi, { SubscriberData } from '../../apis/subscriber.api'
import addonApi, { AddonData } from '../../apis/addon.api'
import metaApi, { MetaCreateRequest } from '../../apis/meta.api'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Card from '../../components/Card'
import Row from '../../components/Row/Row'
import PageHeading from '../../components/PageHeading'
import Select from '../../components/Select'
import CardButton from '../../components/CardButton'
import MetaModifyValueInput from '../../partials/admin/MetaModifyValueInput'
import MetaCreateAttributableInput from '../../partials/admin/MetaCreateAttributableInput'

interface MetaCreateProps extends RouteComponentProps {}

interface MetaCreateState {
  subscriber: string
  addon: string
  item: string
  value: string
  attributable: string
  attributableId: number | null
  subscribers: SubscriberData[]
  addons: AddonData[]
}

class MetaCreate extends Component<MetaCreateProps, MetaCreateState> {
  constructor (props: MetaCreateProps) {
    super(props)
    this.state = {
      subscriber: '',
      addon: '',
      item: '',
      value: '',
      attributable: '',
      attributableId: null,
      subscribers: [],
      addons: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleAttributableChange = this.handleAttributableChange.bind(this)
  }

  get subscriberSelectOptions () {
    return subscriberService.selectOptions(this.state.subscribers)
  }

  get addonSelectOptions () {
    return addonService.selectOptions(this.state.addons)
  }

  get addonName () {
    const { addon, addons } = this.state
    const addonId = Number(addon)
    const foundAddon = addonService.find(addons, addonId)
    if (!foundAddon) return null
    return foundAddon.name
  }

  get valueInput () {
    return this.addonName &&
      <MetaModifyValueInput
        value={this.state.value}
        addon={this.addonName}
        onChange={this.handleInputChange} />
  }

  get attributableInput () {
    const { subscriber } = this.state
    return this.addonName && subscriber &&
      <MetaCreateAttributableInput
        addon={this.addonName}
        subscriber={Number(subscriber)}
        value={this.state.attributable}
        onChange={this.handleAttributableChange} />
  }

  create () {
    const { subscriber, addon, value, attributableId } = this.state
    const payload: MetaCreateRequest = {}
    if (subscriber) payload.subscriber = Number(subscriber)
    if (addon) payload.addon = Number(addon)
    if (value) payload.value = value
    if (attributableId) payload.attributable = attributableId
    metaApi.create(payload, meta => {
      if (!meta) return
      this.props.history.push(adminRoutes.metas)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'subscriber') this.setState({ subscriber: value })
    else if (name === 'addon') this.setState({ addon: value })
    else if (name === 'value') this.setState({ value })
  }

  handleCreateClick () {
    this.create()
  }

  handleAttributableChange (
    attributable: string,
    attributableId?: number
  ) {
    this.setState({ attributable })
    if (attributableId) this.setState({ attributableId })
  }

  listSubscribers () {
    subscriberApi.list(subscribers => {
      if (!subscribers) return
      this.setState({ subscribers })
    })
  }

  listAddons () {
    addonApi.list(addons => {
      if (!addons) return
      this.setState({ addons })
    })
  }

  componentDidMount () {
    this.listSubscribers()
    this.listAddons()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading text={i18n("Create Meta")} />
            <Row column={2}>
              <Select
                name="subscriber"
                value={this.state.subscriber}
                options={this.subscriberSelectOptions}
                label={i18n("Subscriber")}
                onChange={this.handleInputChange} />
              <Select
                name="addon"
                value={this.state.addon}
                options={this.addonSelectOptions}
                label={i18n("Addon")}
                onChange={this.handleInputChange} />
              {this.valueInput}
              {this.attributableInput}
            </Row>
            <CardButton
              proceedText={i18n("Create")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleCreateClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(MetaCreate)
